export default "__VITE_PUBLIC_ASSET__969a2f79__"